import DashboardContentHeading from '../DashboardContentHeading/DashboardContentHeading';
import RecentPurCard from './RecentPurCard/RecentPurCard';
import classes from './RecentPurchases.module.scss';
import { useState, useEffect, useContext } from 'react';
import AuthContext from '../../../store/auth-context';
import { getUserPurchaseDetails, formatPurchaseCarName } from '../../../services/purchaseService';
import EmptyContentCard from '../../Layout/EmptyContentCard';
import { useNavigate } from 'react-router';

// Add this component before RecentPurchases
const RecentPurchasesSkeleton = () => {
    return (
        <div className={classes.skeletonCard}>
            <div className={classes.header}>
                <div className={classes.title}></div>
                <div className={classes.status}></div>
            </div>
            <div className={classes.content}>
                <div className={classes.details}>
                    <div className={classes.detail}></div>
                    <div className={classes.detail}></div>
                </div>
                <div className={classes.price}></div>
            </div>
        </div>
    );
};

const RecentPurchases = () => {
    const [purchases, setPurchases] = useState([]);
    const [loading, setLoading] = useState(true);
    const authCtx = useContext(AuthContext);
    const userData = authCtx.userData;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPurchases = async () => {
            if (!authCtx.isLoggedIn || !userData?.userId) {
                setLoading(false);
                return;
            }

            setLoading(true);
            
            try {
                // Use the dedicated purchase service
                const purchaseData = await getUserPurchaseDetails(userData.userId);
                
                if (purchaseData && purchaseData.length > 0) {
                    // Sort by createdAt timestamp (newest first)
                    const sortedPurchases = [...purchaseData].sort((a, b) => 
                        new Date(b.createdAt) - new Date(a.createdAt)
                    );
                    
                    console.log('Formatted purchases:', sortedPurchases);
                    setPurchases(sortedPurchases);
                } else {
                    setPurchases([]);
                }
            } catch (error) {
                console.error('Error fetching purchases:', error);
                setPurchases([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPurchases();
    }, [authCtx.isLoggedIn, userData]);


    return (
        <div className={classes.RecentPurchases}>
        <div className={classes.RecentPurchasesHeading}>

            <DashboardContentHeading iconText='purchases' />
            
            <div className={classes.RecentPurchasesCardContainer}>
                {loading ? (
                    [...Array(3)].map((_, index) => (
                        <RecentPurchasesSkeleton key={index} />
                    ))
                ) : purchases.length > 0 ? (
                    purchases.slice(0, 3).map((content, index) => (
                        <RecentPurCard content={content} key={index}/>
                    ))
                ) : (
                    <EmptyContentCard 
                        header="You don't have any purchases yet." 
                        message="Explore our assets and mark the ones you like the most, so you don't lose sight of them." 
                    />
                )}

            </div>
            </div>

            <div className={classes.AllPurBtnContainer} style={{
                display: 'flex',
                justifyContent: 'flex-start',
                width: '100%',
                paddingLeft: '20px'
            }}>
                <button 
                    className='whiteAndPurp' 
                    style={{
                        margin: "20px 0px 10px",
                        width: 'auto',
                        minWidth: '180px'
                    }} 
                    onClick={() => navigate('/garage?source=auction&tab=purchases')}
                >
                    See all Purchases
                </button>
            </div>
        </div>
    )
};

export default RecentPurchases;